import React from 'react';
// Update to use new styles structure - CSS is imported from styles/index.js
import './styles/locationList.css';
import { useTp } from '../context/TpContext';

// Location point type definitions
export const LocationType = {
  // Location point types, can be extended as needed
  NORMAL: 'normal', // Normal location point
  START: 'start',   // Starting point
  END: 'end',       // End point
  WAYPOINT: 'waypoint' // Waypoint
};

// Initialize sample data (optional)
export const initialLocations = [
  { id: '1', name: '1', latitude: -37.8136, longitude: 144.9631, type: LocationType.NORMAL },
  { id: '2', name: '2', latitude: -37.8236, longitude: 144.9531, type: LocationType.NORMAL }
];

const LocationList = ({ 
  locations: passedLocations, 
  mode,
  readOnly = false,       // Whether in read-only mode
  showActions = true,     // Whether to show action buttons
  allowDelete = true,     // Whether to allow location deletion
  onLocationChange
}) => {
  // Get jump to location functionality from TP context
  const { jumpToLocation, locations: contextLocations, setLocations } = useTp();
  
  // Use passed locations or fall back to context locations, ensure it's always an array
  const rawLocations = passedLocations || contextLocations || [];
  
  // Additional safety check
  const locations = Array.isArray(rawLocations) ? rawLocations : [];
  if (!Array.isArray(rawLocations)) {
    console.warn('LocationList: locations is not an array, defaulting to empty array');
  }
  
  const handleLocationChange = onLocationChange || setLocations;
  
  // Handle clicking on a location to jump to it on the map
  const handleLocationClick = (location) => {
    if (jumpToLocation) {
      jumpToLocation(location.latitude, location.longitude);
    }
  };

  // Handle location deletion
  const handleDeleteLocation = (id) => {
    if (readOnly) return;
    
    // Create new location list excluding the point to delete
    const newLocations = locations.filter(location => location.id !== id);
    
    // Renumber all location points (keep all original data)
    const renumberedLocations = newLocations.map((location, index) => ({
      ...location,
      name: `${index + 1}`
    }));
    
    handleLocationChange(renumberedLocations);
  };





  // Show different empty state message based on mode
  const getEmptyStateMessage = () => {
    switch (mode) {
      case 'Setup Points':
        return 'No location points. Upload a CSV file above to add points.';
      case 'Custom Path':
        return 'No location points. Please add points in Setup Points mode first.';
      case 'Auto Path':
        return 'No location points. Please add points in Setup Points mode first.';
      default:
        return 'No location points.';
    }
  };

  return (
    <div className="location-list-container">
      <h4 className="location-list-title">Location Points</h4>
      
      {/* Location points list */}
      {locations.length > 0 ? (
        <div className="location-list">
          {locations.map(location => (
            <div key={location.id} className="location-item">
              <div 
                className="location-item-content clickable-location"
                onClick={() => handleLocationClick(location)}
                title="Click to jump to this location on the map"
              >
                <div className="location-content">
                  <div className="location-main">
                    {location.number || location.name}. {(location.latitude || 0).toFixed(4)}, {(location.longitude || 0).toFixed(4)}
                  </div>
                  {location.tpType && (
                    <div className="location-details">
                      <span className={`type-badge ${location.tpType}`}>
                        {location.tpType.toUpperCase()}
                      </span>
                      {location.quantity && (
                        <span className="quantity-info">
                          Qty: {location.quantity}
                        </span>
                      )}
                      {location.address && (
                        <span className="address-info">
                          {location.address}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {showActions && (
                <div className="location-item-actions">
                  {/* Delete button */}
                  {!readOnly && allowDelete && (
                    <button 
                      onClick={() => handleDeleteLocation(location.id)}
                      className="action-btn delete-btn"
                      title="Delete"
                    >
                      ✕
                    </button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>{getEmptyStateMessage()}</p>
        </div>
      )}
    </div>
  );
};

export default LocationList;
